import React from 'react';

class SearchPiece extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  getData(data, section){
    var card = {};
    var cards = [];
    var prop;
    if(!data || !data[section]) {
      return [];
    }

    function toArray(card){
      var arr = [];
      for(prop in card){
        if(prop === "") continue;
        arr.push({name:prop, value:card[prop]});
      }      
      return arr;      
    }

    var m;
    if(data[section].length > 0){
      for(var i = 0; i < data[section].length; i++){
        m = data[section][i];
        for(prop in m){
          this.setProp(prop, m, prop, card);        
        }
        cards.push(toArray(card));
      }      
    } else {
      m = data[section];
      for(prop in data[section]){
        this.setProp(prop, m, prop, card);        
      }      
      cards.push(toArray(card));
    }

    return cards;
  }

  setProp_(propName, source, target){
    return this.setProp(propName, source, propName, target);
  }

  setProp(propName, source, propTarget, target){
    if (source[propName]){
      target[propTarget] = source[propName];
      //delete source[propName];
      var data = target[propTarget];
      if(data.length > 10){
        data = data.substring(0, 10) + "...";  
      }
      return `[${propTarget}:${data}]`;
    }
    
    return "";
  }
}

export default (SearchPiece);


// WEBPACK FOOTER //
// ./src/search/pieces/search_piece.js